import React, { useState, useEffect } from "react";
/** Components Import */
import { Button } from "react-bootstrap";

function BasicButton({
  className = "",
  style = {},
  title = "Button",
  shape = "normal", // 'contain', 'outline', 'link'
  variant = "primary", // 'primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'light', 'link'
  size = "md", // 'sm' | 'md' | 'lg'
  type = "button", // 'button' | 'reset' | 'submit' | null
  disabled = false,
  fullWidth = false,
  href,
  as,
  onClick = () => {},
}) {
  const [variantResult, setVariantResult] = useState("");
  const [blocked, setBlocked] = useState("");

  useEffect(() => {
    if (shape === "outline") {
      setVariantResult(shape + "-" + variant);
    } else if (shape === "link") {
      setVariantResult("link");
    } else {
      setVariantResult(variant);
    }

    if (fullWidth) {
      setBlocked("d-grid gap-2");
    } else {
      setBlocked("");
    }
  }, []);

  const ButtonClick = () => {
    onClick();
  };

  return (
    <React.Fragment>
      {fullWidth ? (
        <div className={blocked}>
          <Button
            className={className}
            style={{ textDecorationLine: "none", ...style }}
            variant={variantResult}
            type={type}
            size={size}
            disabled={disabled}
            href={href}
            as={as}
            onClick={ButtonClick}
          >
            {title}
          </Button>
        </div>
      ) : (
        <Button
          className={className}
          style={{ textDecorationLine: "none", ...style }}
          variant={variantResult}
          type={type}
          size={size}
          disabled={disabled}
          href={href}
          as={as}
          onClick={ButtonClick}
        >
          {title}
        </Button>
      )}
    </React.Fragment>
  );
}

export default BasicButton;
